'use client';

import { c } from '../../../utils/tailwind-merge';
import { ProductRating } from '../ProductRating';
import { ProductReviews } from '../ProductReviews';
import { ReviewListProps } from './ReviewList.types';

export const ReviewList = ({
  microcopy,
  className,
  reviewStars,
  reviewList,
  canWriteReview,
  onFilterReviews,
  onWriteReview,
  onEditReply,
  onDeleteReply,
  onEditReview,
  onDeleteReview,
  onSubmitReport,
  onSubmitReply,
  onSort,
  onPageChange,
  onFilter,
  onHelpfulVotesReview,
  onHelpfulVotesReply,
  reviews,
  start,
  end,
  total,
  currentPage,
  totalPages,
}: ReviewListProps) => {
  return (
    <section className={c('max-w-3xl', className)}>
      {reviews.length !== 0 ? (
        <ProductRating
          reviewList={reviewList}
          reviewStars={reviewStars}
          canWriteReview={canWriteReview}
          overall={microcopy.productRating.overall}
          writeReview={microcopy.productRating.writeReview}
          reviews={microcopy.productRating.reviews}
          ariaLabel={microcopy.productRating.ariaLabel}
          onFilterReviews={onFilterReviews}
          onWriteReview={onWriteReview}
          microcopy={{
            ...microcopy.productRating,
            rating: microcopy.productRating.microcopy.rating,
            ratings: microcopy.productRating.microcopy.ratings,
            ratingAriaLabel: microcopy.productRating.microcopy.ratingAriaLabel,
          }}
          className="mb-8"
        />
      ) : null}

      <ProductReviews
        microcopy={microcopy.productReviews}
        reviews={reviews}
        start={start}
        end={end}
        total={total}
        currentPage={currentPage}
        totalPages={totalPages}
        onHelpfulVotesReview={onHelpfulVotesReview}
        onEditReview={onEditReview}
        onDeleteReview={onDeleteReview}
        onHelpfulVotesReply={onHelpfulVotesReply}
        onEditReply={onEditReply}
        onDeleteReply={onDeleteReply}
        onSubmitReply={onSubmitReply}
        onFilter={onFilter}
        onSort={onSort}
        onPageChange={onPageChange}
        onSubmitReport={onSubmitReport}
      />
    </section>
  );
};
